// extracted by mini-css-extract-plugin
export default {"center":"default_center__t1TAw","browserList":"default_browserList__+634H"};